import React from "react";
import useTranslation from "next-translate/useTranslation";
import Popup from "../components/Popup";
import Spinner from "../components/Spinner";
import { useWsConnection } from "../ducks/wsConnection";

export default function ReconnectPopup() {
  const { reconnectTime, reconnectStart } = useWsConnection();

  const { t } = useTranslation("common");

  if (!reconnectStart) {
    return null;
  }
  const sinceStart = Math.round((reconnectTime - reconnectStart) / 1000);
  if (sinceStart < 3) {
    return null;
  }
  return (
    <Popup
      onClose={null}
      title={t("Connection lost") + ". " + t("Reconnecting")}
    >
      <div style={{ padding: "10px" }}>
        <Spinner blue />
      </div>
    </Popup>
  );
}
